function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.9024 18.4799V16.8199H6.66235V18.4799H10.8824V30.9999H12.6824V18.4799H16.9024Z",
  fill: "#333333"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.1441 30.9999L25.0441 22.2199L29.6641 16.8199H27.4441L20.9441 24.3799V16.8199H19.1641V30.9999H20.9441V26.9999L23.8241 23.6399L28.0641 30.9999H30.1441Z",
  fill: "#333333"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.2863 27.1999C40.2863 25.7599 39.4463 24.2999 37.9663 23.7999C39.1063 23.3199 40.0063 21.9599 40.0063 20.6599C40.0063 19.4599 39.5863 18.5799 38.8863 17.9399C38.1463 17.2399 37.0863 16.8199 35.9263 16.8199C34.7263 16.8199 33.7263 17.1799 32.9463 17.8199C32.1263 18.4999 31.6263 19.4999 31.6063 20.8799H33.3463C33.3663 20.0399 33.6463 19.3599 34.1863 18.9199C34.6063 18.5799 35.1263 18.3599 35.8863 18.3599C36.6463 18.3599 37.2063 18.6599 37.5863 19.0399C38.0263 19.4599 38.2463 20.0199 38.2463 20.6599C38.2463 22.1199 37.2863 22.9999 35.6863 22.9999H34.8463V24.5799H35.6863C37.3863 24.5799 38.5463 25.4599 38.5463 27.1599C38.5463 27.9199 38.2663 28.4999 37.8863 28.9199C37.4063 29.4599 36.7063 29.7199 35.8663 29.7199C34.9863 29.7199 34.3863 29.3999 33.9663 28.9399C33.5063 28.4599 33.2863 27.7999 33.2463 27.0199H31.5063C31.5263 28.2999 31.9663 29.2799 32.6863 29.9999C33.4663 30.7799 34.5263 31.2599 35.8663 31.2599C37.4263 31.2599 38.4863 30.7799 39.2263 29.9999C39.9063 29.2799 40.2863 28.2799 40.2863 27.1999Z",
  fill: "#333333"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2 1H46V-1H2V1ZM47 2V46H49V2H47ZM46 47H2V49H46V47ZM1 46V2H-1V46H1ZM2 47C1.44772 47 1 46.5523 1 46H-1C-1 47.6569 0.343147 49 2 49V47ZM47 46C47 46.5523 46.5523 47 46 47V49C47.6569 49 49 47.6569 49 46H47ZM46 1C46.5523 1 47 1.44772 47 2H49C49 0.343145 47.6569 -1 46 -1V1ZM2 -1C0.343145 -1 -1 0.343147 -1 2H1C1 1.44772 1.44772 1 2 1V-1Z",
  fill: "#EB5757"
});

var SvgTk3High = function SvgTk3High(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTk3High, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TK3-high.eaa97d09.svg";
export { ForwardRef as ReactComponent };